import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const FiltersSelection = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={() => {
        return (
          <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              id="Vector"
              d="M1 1.5H18V3.672C17.9999 4.20239 17.7759 4.71101 17.3774 5.086L12.6875 9.5V16.5L6.3125 18.5V10L1.5525 5.072C1.19704 4.70393 1.00006 4.2244 1 3.727V1.5Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

FiltersSelection.displayName = "Filters Selection";

export { FiltersSelection };
